export default __webpack_public_path__ + "static/media/illustration-mian-w@3x.e2c1b8f5.webp";